export default {"src":"/uk/_next/static/media/spot-self-employed.06d11267.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};